import { handleActions } from 'redux-actions';

const defaultState = {
  visibleModal: false,
  rootModal: {
    modalName: '',
    ActiveModal: null,
    modalProps: {}
  }
};

/*
export default function componentReducer(state = defaultState, action) {
  switch (action.type) {
    case componentType.TOGGLE_MODAL:
      return {
        ...state,
        rootModal: {
          modalName: action.payload.modalName,
          ActiveModal: action.payload.ActiveModal,
          modalProps: action.payload.modalProps
        }
      }
    default:
      return state;
  }
}
*/

const componentReducer = handleActions(
  {
    TOGGLE_MODAL: (state, action) => {
      return Object.assign({}, state, {
        rootModal: {
          modalProps: action.payload.modalProps,
          modalName: action.payload.modalName,
          ActiveModal: action.payload.ActiveModal
        }
      });
    }
  },
  defaultState
);

export { componentReducer };



// WEBPACK FOOTER //
// ./src/components/reducers.js